/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Audit_Details_Agent_Confirmation_Level_Changed_DescInputs */



/**
* | output |
* | --- |
* | "The confirmation level of the agent \"{agent}\" was changed." |
*
* @param {Audit_Details_Agent_Confirmation_Level_Changed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_confirmation_level_changed_desc = /** @type {((inputs: Audit_Details_Agent_Confirmation_Level_Changed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Confirmation_Level_Changed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Bestätigungsstufe des Agenten "${i?.agent}" wurde geändert.`)
	return /** @type {LocalizedString} */ (`The confirmation level of the agent "${i?.agent}" was changed.`)
});